<template>
  <div>
    <div id="container">
      <i class="fa fa-spinner spin fa-2x text-white" v-if="waiting"></i>
      <iframe :src="src" v-if="!waiting"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pdfPreview',
  props: {
    src: {
      type: String,
      default: null
    },
    waiting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  }
}
</script>
<style scoped>
#container {
  width: 100%;
  height: 635px;
  background: black;
  text-align: center;
}
#container iframe {
  width: 100%;
  height: 635px;
  border: 2px solid #acacac;
}
#container i {
  margin-top: 32vh;
}
</style>
